"use client";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useRouter } from "next/navigation";
import { useState } from "react";

export function AuditForm() {
	const [url, setUrl] = useState("");
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");
	const router = useRouter();

	function handleSubmit(e: React.FormEvent) {
		e.preventDefault();
		if (!url.trim()) return;
		setLoading(true);
		setError("");

		try {
			let input = url.trim();
			if (!input.startsWith("http")) input = `https://${input}`;
			const parsed = new URL(input);
			const domain = parsed.hostname.replace(/^www\./, "");
			router.push(`/audit/${domain}`);
		} catch {
			setError("Invalid URL. Check and try again.");
			setLoading(false);
		}
	}

	return (
		<>
			<form onSubmit={handleSubmit} className="flex w-full flex-col gap-3 sm:flex-row">
				<div className="relative flex-1">
					<div className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2">
						<svg
							width="16"
							height="16"
							viewBox="0 0 16 16"
							fill="none"
							className="text-muted-foreground"
						>
							<path
								d="M2.5 8C2.5 4.96 4.96 2.5 8 2.5C11.04 2.5 13.5 4.96 13.5 8C13.5 11.04 11.04 13.5 8 13.5C4.96 13.5 2.5 11.04 2.5 8Z"
								stroke="currentColor"
								strokeWidth="1.2"
							/>
							<path d="M8 2.5V1" stroke="currentColor" strokeWidth="1.2" />
							<path d="M13.5 8H15" stroke="currentColor" strokeWidth="1.2" />
							<path d="M8 15V13.5" stroke="currentColor" strokeWidth="1.2" />
							<path d="M1 8H2.5" stroke="currentColor" strokeWidth="1.2" />
						</svg>
					</div>
					<Input
						type="text"
						placeholder="https://your-site.com"
						value={url}
						onChange={(e) => setUrl(e.target.value)}
						className="h-12 rounded-lg border-border bg-card pl-11 font-mono text-sm shadow-none transition-all focus-visible:border-indigo-500/50 focus-visible:ring-indigo-500/20"
					/>
				</div>
				<Button
					type="submit"
					disabled={loading}
					className="h-12 rounded-lg bg-indigo-500 px-8 font-mono text-sm font-medium tracking-wide text-white shadow-lg shadow-indigo-500/20 transition-all hover:bg-indigo-400 hover:shadow-indigo-500/30 disabled:opacity-60"
				>
					{loading ? (
						<span className="flex items-center gap-2">
							<svg className="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none">
								<circle
									cx="12"
									cy="12"
									r="10"
									stroke="currentColor"
									strokeWidth="3"
									strokeLinecap="round"
									className="opacity-20"
								/>
								<path
									d="M12 2a10 10 0 0 1 10 10"
									stroke="currentColor"
									strokeWidth="3"
									strokeLinecap="round"
								/>
							</svg>
							Analyzing
						</span>
					) : (
						"Run Free Audit"
					)}
				</Button>
			</form>

			{error && <p className="mt-4 font-mono text-xs text-red-400">{error}</p>}

			<p className="mt-5 font-mono text-xs text-muted-foreground/60">
				20 SEO checks &middot; Results in seconds
			</p>
		</>
	);
}
